import axios from '../../http'

class XBUser {
  // xb账号登录
  postXBAccountLogin(username, password) {
    const url = '/api/xb/login'
    const data = {
      username,
      password
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // xb找回密码/验证码登录，发送验证码
  getXBSendCode(telephone) {
    const url = `/api/common/fore/send/code?telephone=${telephone}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // xb手机验证码登录
  postXBPhoneLogin(telephone, code) {
    const url = '/api/xb/sms/login'
    const data = {
      telephone,
      code
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  };
  // xb注册发送验证码
  getXBRegisterSendCode(telephone) {
    const url = `/api/common/fore/sign/send/code?telephone=${telephone}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb校验验证码
  getXBCheckCode(telephone, code) {
    const url = '/api/common/fore/check/code'
    const data = {
      telephone,
      code
    }
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb注册
  postXBRegister(surePassword, contact, name, inviteCode, qq, province, city, regions, address, data) {
    const url = '/api/xb/register'
    const datas = {
      surePassword,
      contact,
      name,
      inviteCode,
      qq,
      province,
      city,
      regions,
      address,
      data,
    }
    return axios.post(url, datas).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb忘记密码重置
  postXBPassword(surePassword, newPassword, data) {
    const url = '/api/xb/modify'
    const datas = {
      surePassword,
      newPassword,
      data
    }
    return axios.post(url, datas).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb退出登录
  getXBLogout() {
    const url = `/api/xb/logout`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb注册是否开启企业注册
  getXBBusiness() {
    const url = `/api/index/business/setting`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 个人中心--获取xb个人信息
  getXbInfo() {
    const url = `/api/xb/info`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 个人中心--修改个人信息
  updateXbInfo(data) {
    const url = `/api/xb/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 填写旧手机号获取验证码
  getVerifyCodeByOldMobile(mobile) {
    const url = `/api/common/fore/send/code?telephone=${mobile}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 验证旧手机号收到得验证码是否正确
  checkCodeWithOldMobile(data) {
    const url = `/api/common/fore/check/code`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 填写新手机号获取验证码
  getVerifyCodeByNewMobile(mobile) {
    const url = `/api/common/fore/sign/send/code?telephone=${mobile}`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 验证新手机号收到的验证码是否正确并更新手机号码
  checkCodeWithNewMobile(data) {
    const url = `/api/xb/newmobile/smscode/verify`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb--个人中心--修改密码
  updatePassword(data) {
    const url = `/api/xb/pass/modify`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 个人中心--获取xb收货地址列表
  getXbShippingAddressList() {
    const url = `/api/xb/address/list`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 个人中心--新增一个xb收货地址
  addXbShippingAddress(data) {
    const url = `/api/xb/address/add`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 个人中心--修改xb某个收货地址
  updateXbShippingAddressById(data) {
    console.log('数据--', data)
    const url = `/api/xb/address/update`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // 个人中心--删除一个xb收货地址
  deleteXbShippingAddressById(data) {
    const url = `/api/xb/address/del`
    return axios.post(url, data).then((res) => {
      return Promise.resolve(res.data)
    })
  }
  // xb首页广告弹窗
  getXBAdvertisement() {
    const url = `/api/index/ad`
    return axios.get(url).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default XBUser;
